export const isDev = () => {
	return !/^production|staging$/.test(window.Stash.env);
};

export const isProd = () => {
	return /^production$/.test(window.Stash.env);
};

export const isNotProd = () => {
	return !/^production$/.test(window.Stash.env);
};

export const isLocal = () => {
	return /^__STASH_ENV__$/.test(window.Stash.env);
};
